import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { ChunkSearchSchema } from '@/features/data-connector/chunks';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/',
)({
  validateSearch: zodValidator(ChunkSearchSchema),
});
